import { Link } from "react-router-dom";
import Tags from "./Tags";
import Button from "./Button";
import Image from "./Image";
import { Car } from "../data/models";

export interface ResponsiveCardProps {
  car: Car;
}

export function ResponsiveCard(props: ResponsiveCardProps) {
  const { car } = props;
  const tags = [car.type_hr, car.color_design, car.trim_design];

  return (
    <>
      {/* Layout on medium and large screens */}
      <div className="hidden gap-6 sm:flex bg-primary-white">
        <Link to={`/car/${car.id}`}>
          <div className="relative">
            {car.akcija_text2 && (
              <div className="absolute font-bold text-[11px] py-1 px-1.5 top-2 left-2 rounded-sm text-white bg-primary-blue">
                PROMO
              </div>
            )}
            <Image image={car.link}></Image>
          </div>
        </Link>
        <div className="flex flex-col justify-between w-full gap-8">
          <div className="flex flex-col gap-3">
            <Link to={`/car/${car.id}`}>
              <h3 className="text-base font-bold uppercase text-gray-extra-dark">
                {car.brand}&nbsp;{car.family}
                {car.vehicle_state_hr === "Vozilo u dolasku" && (
                  <span className="block px-1 py-1 mt-1 text-xs border lg:mt-0 lg:ml-2 size-fit lg:inline-block text-primary-blue border-primary-blue">
                    U dolasku
                  </span>
                )}
              </h3>
            </Link>
            <p className="text-xs text-gray-extra-dark opacity-80">
              {car.model_designation}
            </p>
            <p className="text-[10px] text-gray-extra-dark opacity-70">
              {car.vin}
            </p>
            <Tags tags={tags}></Tags>
          </div>

          <div className="flex flex-col gap-3">
            {car.mask_price !== "0" && car.mask_price?.length > 0 ? (
              <div className="flex gap-2">
                {car.mask_price_akcija?.length > 0 ? (
                  <>
                    <p className="text-lg sm:text-xl text-primary-blue">
                      {Number(car.mask_price_akcija).toLocaleString("de-DE", {
                        maximumFractionDigits: 0,
                      })}{" "}
                      €
                    </p>
                    <p className="flex items-end pb-[3px] text-xs text-gray-extra-dark text-opacity-80 line-through decoration-primary-blue">
                      {Number(car.mask_price).toLocaleString("de-DE", {
                        maximumFractionDigits: 0,
                      })}{" "}
                      €
                    </p>
                  </>
                ) : (
                  <p className="text-lg sm:text-xl text-primary-black">
                    {Number(car.mask_price).toLocaleString("de-DE", {
                      maximumFractionDigits: 0,
                    })}{" "}
                    €
                  </p>
                )}
              </div>
            ) : (
              <p className="text-sm font-bold text-primary-blue whitespace-nowrap">
                Cijena na upit
              </p>
            )}

            <p className="text-xs text-gray-dark">
              {car.co2_hr?.length > 0 && car.co2_hr !== "-" && (
                <>{car.co2_hr}&nbsp;·&nbsp;</>
              )}
              {car.transmission_type?.length > 0 && car.transmission_type}
              {car.mask_potrosnja?.length > 0 && car.mask_potrosnja !== "-" && (
                <>&nbsp;·&nbsp;{car.mask_potrosnja}</>
              )}
            </p>

            <div className="flex justify-between">
              <Link to={`/car/${car.id}`}>
                <Button
                  text={"Saznajte više"}
                  variant={"primary"}
                  size={"base"}
                ></Button>
              </Link>
              <div className="flex flex-col gap-1">
                <p className="items-center text-sm text-right uppercase">
                  {car.dealer}
                </p>
                <p className="items-center text-sm text-right opacity-35">
                  {car.dealer_city}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Layout on small screens */}
      <div className="flex flex-col gap-4 px-4 bg-primary-white sm:hidden">
        <div className="flex items-end justify-between gap-3">
          <div className="flex flex-col gap-2">
            <Link to={`/car/${car.id}`}>
              <h3 className="text-base font-bold uppercase text-gray-extra-dark">
                {car.brand}&nbsp;{car.family}
                {car.vehicle_state_hr === "Vozilo u dolasku" && (
                  <span className="block px-1 py-1 mt-1 text-xs border size-fit text-primary-blue border-primary-blue">
                    U dolasku
                  </span>
                )}
              </h3>
            </Link>
            <div className="flex flex-col gap-1">
              <p className="items-center text-sm">{car.dealer}</p>
              <p className="text-sm opacity-35">{car.dealer_city}</p>
            </div>
          </div>

          {car.mask_price !== "0" && car.mask_price?.length > 0 ? (
            <div className="flex flex-col gap-[2px]">
              {car.mask_price_akcija?.length > 0 ? (
                <>
                  <p className="self-end text-lg font-bold text-primary-blue whitespace-nowrap">
                    {Number(car.mask_price_akcija).toLocaleString("de-DE", {
                      maximumFractionDigits: 0,
                    })}{" "}
                    €
                  </p>
                  <p className="self-end text-[11px] text-gray-extra-dark text-opacity-80 whitespace-nowrap line-through decoration-primary-blue">
                    {Number(car.mask_price).toLocaleString("de-DE", {
                      maximumFractionDigits: 0,
                    })}{" "}
                    €
                  </p>
                </>
              ) : (
                <p className="self-end text-lg font-bold text-primary-black whitespace-nowrap">
                  {Number(car.mask_price).toLocaleString("de-DE", {
                    maximumFractionDigits: 0,
                  })}{" "}
                  €
                </p>
              )}
            </div>
          ) : (
            <p className="text-sm font-bold text-primary-blue whitespace-nowrap">
              Cijena na upit
            </p>
          )}
        </div>

        <Link to={`/car/${car.id}`}>
          <div className="relative">
            {car.akcija_text2 && (
              <div className="absolute font-bold text-[11px] py-1 px-1.5 top-2 left-2 rounded-sm text-white bg-primary-blue">
                PROMO
              </div>
            )}
            <Image image={car.link}></Image>
          </div>
        </Link>

        <div className="flex flex-col gap-3">
          <p className="text-xs text-gray-extra-dark opacity-80">
            {car.model_designation}
          </p>
          <p className="text-[10px] text-gray-extra-dark opacity-70">
            {car.vin}
          </p>
          <Tags tags={tags}></Tags>
        </div>

        <div className="flex flex-col gap-3">
          <p className="text-xs text-gray-dark">
            {car.co2_hr?.length > 0 && car.co2_hr !== "-" && (
              <>{car.co2_hr}&nbsp;·&nbsp;</>
            )}
            {car.transmission_type?.length > 0 && car.transmission_type}
            {car.mask_potrosnja?.length > 0 && car.mask_potrosnja !== "-" && (
              <>&nbsp;·&nbsp;{car.mask_potrosnja}</>
            )}
          </p>
          <Link to={`/car/${car.id}`}>
            <Button
              text={"Saznajte više"}
              variant={"primary"}
              size={"base"}
              width="w-full"
            ></Button>
          </Link>
        </div>
      </div>
    </>
  );
}

export default ResponsiveCard;
